import { render } from "./LearnLinks.vue?vue&type=template&id=bf1a2f6a"
import script from "./LearnLinks.vue?vue&type=script&lang=js"
export * from "./LearnLinks.vue?vue&type=script&lang=js"

import "./LearnLinks.vue?vue&type=style&index=0&id=bf1a2f6a&lang=css"

import exportComponent from "/home/chris/tw/src/attendctrl/attend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__